<template>
  <div v-if="faq != null">
    <div class="block mb-5">
      <!-- ID -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>ID</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-faq-autocomplete">
            <input type="text" disabled :value="faq.id" />
          </div>
          <div class="ml-10px ink-02-medium--text h5">(自動生成)</div>
        </div>
      </div>
      <!-- Bu -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Bu</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-faq-autocomplete">
            <v-autocomplete
              v-model="faq.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- 選擇FAQ分類 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Category</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2">
          <div class="w-248px mr-5 support-faq-autocomplete">
            <v-autocomplete
              :items="categories"
              v-model="faq.product_category_id"
              placeholder="請選擇FAQ分類"
              item-value="id"
              item-text="name"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </div>
      <!-- Model Name -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5"><h4>Model Name</h4></div>
        <div class="flex-grow-1 flew-basis-0 my-n2 d-flex mr-5">
          <div class="w-480px mr-5 support-faq-autocomplete">
            <MultiSelectWithCheckbox
                v-model="faq.product_ids"
                :items="selectCategory(faq.product_category_id)"
                item-value="id"
                item-text="product_with_subcategory"
              >
            </MultiSelectWithCheckbox>
          </div>
        </div>
      </div>
      <!-- Question -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Question</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="faq.question"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="faq.status"></FormSwitch>
        </div>
      </div>
      <!-- General FAQ -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>General FAQ</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="faq.popularYN"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <div class="form-item d-flex py-5">
        <div class="w-220px mr-8">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="faq.order"
            placeholder="請輸入序號"
            class="w-248px"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="faq.ans"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'link|fontsize select|image'"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from '@/components/TinymceEditor.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import FormSwitch from '@/components/FormSwitch.vue';

export default {
  components: {
    MultiSelectWithCheckbox,
    Editor,
    FormSwitch,
  },
  data: () => ({
    categories: [],
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['languages']),
    ...mapState('supportFaq', ['faq']),
  },
  watch: {
    async 'faq.bu_id'() {
      this.categories = await this.allByBu(this.faq.bu_id);
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    selectCategory(id) {
      const category = this.categories.find((item) => item.id === id);
      if (category) {
        return category.products;
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
.support-faq-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}
</style>
